<div class="card-header">
  <h1>Wachtwoordherstel</h1>
</div>
<div class="card-body">
  <div *ngIf="!linkAlreadyUsed">
    <form (ngSubmit)="setPassword(form.value)" [formGroup]="form" class="form">
      <div [ngClass]="{ 'input-error': submitted && f.password.errors }">
        <h2>voer een nieuw wachtwoord in</h2>
        <label class="form-label" for="password">wachtwoord</label>
        <div class="relative">
          <input appShowPasswordToggle formControlName="password" id="password" type="password">
        </div>
        <div class="errors">
          <div *ngIf="f.password.errors?.required">{{'password.required' | translate}}</div>
          <div *ngIf="f.password.errors?.minlength">{{'password.minLength' | translate}}</div>
        </div>
      </div>
      <div class="spacer"></div>
      <button class="btn check btn-left" type="submit">opslaan</button>
    </form>
  </div>

  <div *ngIf="linkAlreadyUsed">
    <h2>
      deze link is niet meer geldig
    </h2>
     deze link is al gebruikt om een nieuw wachtwoord in te stellen.
    <div class="spacer-small"></div>
    <button class="btn check" routerLink="/wachtwoord-herstel">nieuw wachtwoord aanvragen</button>
  </div>
</div>
